<template>
  <div>
    <p v-if="label != ''">
      {{ label }}
    </p>
    <datepicker
      :date="startDate"
      :option="startOption"
      :limit="startOption.limit"
    ></datepicker>
    <template v-if="type == 'dateBetween'">
      ~
      <datepicker
        :date="endDate"
        :option="endOption"
        :limit="endOption.limit"
      ></datepicker>
    </template>
  </div>
</template>

<script>
import datepicker from "vue-datepicker";
import { ref } from "@vue/reactivity";
import { watch } from "@vue/runtime-core";
export default {
  components: {
    datepicker,
  },
  props: {
    label: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "date", // date/dateBetween
    },
    defaultDate: {
      type: String,
      default: "",
    },
  },
  emits: ["update:getValue"],
  setup(props, { emit }) {
    const type = props.type;
    const defaultDate = props.defaultDate;
    const startOption = {
      type: "day",
      week: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
      month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      format: "YYYY-MM-DD",
      placeholder: "",
      inputStyle: {
        display: "inline-block",
        padding: "6px",
        height: "2.375rem",
        "line-height": "2.375rem",
        "font-size": "0.875rem",
        border: "2px solid #fff",
        "box-shadow": "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
        "border-radius": "2px",
        color: "#5F5F5F",
        width: "6.5rem",
        "font-family": "dfyuanstd-w7",
      },
      color: {
        header: "#ccc",
        headerText: "#f00",
      },
      overlayOpacity: 0.5, // 0.5 as default
      dismissible: true, // as true as default
      limit: [
        {
          type: "fromto",
          from: "1995-01-01",
          to: "9999-01-01",
        },
      ],
    };
    const endOption = {
      type: "day",
      week: ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"],
      month: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      format: "YYYY-MM-DD",
      placeholder: "",
      inputStyle: {
        display: "inline-block",
        padding: "6px",
        height: "2.375rem",
        "line-height": "2.375rem",
        "font-size": "0.875rem",
        border: "2px solid #fff",
        "box-shadow": "0 1px 3px 0 rgba(0, 0, 0, 0.2)",
        "border-radius": "2px",
        color: "#5F5F5F",
        width: "6.5rem",
        "font-family": "dfyuanstd-w7",
      },
      color: {
        header: "#ccc",
        headerText: "#f00",
      },
      overlayOpacity: 0.5, // 0.5 as default
      dismissible: true, // as true as default
      limit: [
        {
          type: "fromto",
          from: "1995-01-01",
          to: "9999-01-01",
        },
      ],
    };

    //初始化日期
    let today = new Date();
    if (defaultDate != "") {
      today = new Date(defaultDate);
    }
    let strMount = (today.getMonth() + 1).toString().padStart(2, "0");
    let strDate = today.getDate().toString().padStart(2, "0");
    const startDate = ref({
      time: today.getFullYear() + "-" + strMount + "-" + strDate,
    });
    const endDate = ref({
      time: today.getFullYear() + "-" + strMount + "-" + strDate,
    });
    //設置查詢起始日限制(從今天往前推算一年)
    let limitDate = today.setFullYear(today.getFullYear() - 1);
    startOption.limit[0].from = limitDate;
    if (type == "dateBetween") {
      emit("update:getValue", {
        startDate: startDate.value.time,
        endDate: endDate.value.time,
      });
    } else {
      emit("update:getValue", { startDate: startDate.value.time });
    }

    //開始時間的watch
    watch(
      startDate,
      (newValue) => {
        //dateBetween 有開始和結束時間
        if (type == "dateBetween") {
          let diff = new Date(endDate.value.time) - new Date(newValue.time);
          if (diff < 0) {
            endDate.value.time = newValue.time; //設定輸入框日期
          }
          //設定結束日期可以選擇的開始時間
          let selectDate = new Date(newValue.time);
          let newYear = selectDate.getFullYear();
          let newMount = (selectDate.getMonth() + 1).toString().padStart(2, "0");
          let newDate = (selectDate.getDate() - 1).toString().padStart(2, "0");
          endOption.limit[0].from = newYear + "-" + newMount + "-" + newDate;

          emit("update:getValue", {
            startDate: startDate.value.time,
            endDate: endDate.value.time,
          });
          return;
        }

        //date 只有單一時間
        emit("update:getValue", { startDate: startDate.value.time });
      },
      { deep: true }
    );
    watch(
      () => props.defaultDate,
      (newValue) => {
        startDate.value.time = newValue;
        emit("update:getValue", { startDate: newValue });
      }
    );

    //結束時間的watch
    if (type == "dateBetween") {
      watch(
        endDate,
        (newValue) => {
          emit("update:getValue", {
            startDate: startDate.value.time,
            endDate: endDate.value.time,
          });
        },
        { deep: true }
      );
    }

    return {
      startDate,
      endDate,
      startOption,
      endOption,
    };
  },
};
</script>

<style scoped>
p {
  margin-bottom: 10px;
}
</style>

<style>
.cov-date-body {
  font-family: dfyuanstd-w7 !important;
}
</style>
